// App.js
import React, { useEffect } from "react";
import "./index.css";
import { Provider as ReduxProvider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reportingReducers from "./redux/reducers";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { Provider as ProviderNorth, teamsTheme } from "@fluentui/react-northstar";
import Welcome from "./components/WelcomeComponent/WelcomeComponent";
import ReportsListPageContainer from "./Containers/ReportsListPageContainer";
import { Providers, Msal2Provider } from "@microsoft/mgt";
import { useMsal } from "@azure/msal-react";


// ===== Redux store =====
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reportingReducers,
  composeEnhancers(applyMiddleware(thunk))
);

// ===== MGT + MSAL integration =====
function MgtIntegration() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length > 0) {
      Providers.globalProvider = new Msal2Provider({
        publicClientApplication: instance,
        scopes: ["User.Read"],
        account: accounts[0],
      });
    } else {
      Providers.globalProvider = null;
    }
  }, [accounts, instance]);

  return null;
}

// ===== Main App =====
function App() {
  const { instance, accounts } = useMsal();

  const handleLogout = async () => {
    const currentAccount = accounts[0];
    try {
      await instance.logoutRedirect({
        account: currentAccount,
        postLogoutRedirectUri: "/",
      });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div>
      <MgtIntegration />
      <Router>
        <IntlProvider locale="en">
          <ProviderNorth theme={teamsTheme}>
            <ReduxProvider store={store}>
              <>
                <Routes>
                  <Route path="/" element={<Welcome />} />
                  <Route path="/ReportsList" element={<ReportsListPageContainer />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </>
            </ReduxProvider>
          </ProviderNorth>
        </IntlProvider>
      </Router>
    </div>
  );
}

export default App;
